import { render, staticRenderFns } from "./ItemImageAssociationCard.vue?vue&type=template&id=7f5aa3d6&"
import script from "./ItemImageAssociationCard.vue?vue&type=script&lang=js&"
export * from "./ItemImageAssociationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports